"use client";

import Link from "next/link";

export const postFilterKey = basePath => `postFilter:${basePath}`;

export default function PostFilterLink({ basePath, filter, children, ...props }) {
  return (
    <Link
      {...props}
      href={basePath}
      onClick={() => {
        try { sessionStorage.setItem(postFilterKey(basePath), JSON.stringify(filter)); } catch {}
      }}
    >
      {children}
    </Link>
  );
}
